<template>
  <span v-for="(proposal, index) in proposals" :key="proposal.path">
    <span v-if="proposal.empty" v-tooltip.placementBottom="tooltipText">
      {{ proposal.name }}
    </span>
    <a v-else :href="proposal.path"> {{ proposal.name }}</a
    ><template v-if="index < proposals.length - 1">, </template>
  </span>
</template>
<script setup lang="ts">
import type { ProposalData } from '../types'

interface Props {
  proposals: Array<ProposalData>
}

defineProps<Props>()

const tooltipText = window.I18n.t('pulse.accept_all_empty_warning')
</script>
